export class APIError extends Error {
  constructor(...args) {
    super(...args);
    this.name = 'APIError';
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, APIError);
    }
  }
}

export class UIError extends Error {
  constructor(...args) {
    super(...args);
    this.name = 'UIError';
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, APIError);
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/errors.js